import CreateWindow from "../puzzleWindow";
import background from "./tausta.jpg";
import backgroundTest from "./taust_test.jpg";
import { html, render } from "lit-html";
import "./index.css";
import { tips } from "~/src/tips";
import button from "./button.png";
import equal from "deep-equal";
import buttonBG from "./nappuloiden_tausta.jpg";
import { getArrayRandomElement } from "~/src/helpers/getArrayRandomElement.js";
import { exitButtonPosition } from "../../helpers/exitButtonPosition";
let correct = {
  A: { 1: true, 2: false, 3: false, 4: true },
  B: { 1: false, 2: true, 3: false, 4: true },
  C: { 1: false, 2: false, 3: true, 4: false },
  D: { 1: true, 2: true, 3: false, 4: true },
};

let data = {
  A: { 1: false, 2: true, 3: false, 4: true },
  B: { 1: true, 2: false, 3: false, 4: false },
  C: { 1: false, 2: false, 3: true, 4: true },
  D: { 1: true, 2: false, 3: false, 4: false },
};

const endAnimation = (cb) => {
  const rowAlternatives = ["A", "B", "C", "D"];
  const colAlternatives = ["1", "2", "3", "4"];
  const numberAlternatives = [1, 2, 3, 4, 5];

  let times = (n) => {
    return (f) => {
      Array(n)
        .fill()
        .map((_, i) => f(i));
    };
  };

  const setAllFalse = (obj) => {
    const iterate = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === "object") {
          iterate(obj[key]);
        } else {
          obj[key] = false;
        }
      });
    };
    iterate(obj);
  };

  setAllFalse(data);
  setInterval(() => {
    setAllFalse(data);
    const numRandom = getArrayRandomElement(numberAlternatives);
    const putRandomOn = () => {
      const rowRandom = getArrayRandomElement(rowAlternatives);
      const colRandom = getArrayRandomElement(colAlternatives);

      data[rowRandom][colRandom] = true;
    };
    times(numRandom)(putRandomOn);
    cb();
  }, 200);
};

let randomStyleValues = {};

const FlatPuzzle = function (callback) {
  const lockerPiece = (row, column) => {
    const id = `${row}.${column}`;
    const getRandomStyle = () => {
      if (!randomStyleValues[id]) {
        const randomTop = Math.floor(Math.random() * 200) + 1
        const randomLeft = Math.floor(Math.random() * 200) + 1    
        const random = `background-image: url('${buttonBG}'); background-position-y: -${randomTop}px; background-position-x: -${randomLeft}px`
        randomStyleValues = { ...randomStyleValues, [id]: random };
      }
    };

    getRandomStyle();
    
        //@clicsdfk=${() => changeValue(row, column)}
    return html`<div class="locker-piece-container">
      <div

        class=${`${data[row][column] ? "locker-piece" : "locker-piece closed"}`}
        @click=${(e) => changeValue(row, column)}
        style=${randomStyleValues[id]}
      >
      </div>
    </div>`;
  };
   let puzzleWindow
  const renderStuff = () => {
    const markup = html`
      <div class="locker-container">
        <div class="locker-grid">
          <div class="locker-row">
            ${lockerPiece("A", 1)} ${lockerPiece("A", 2)} ${lockerPiece("A", 3)}
            ${lockerPiece("A", 4)}
          </div>
          <div class="locker-row">
            ${lockerPiece("B", 1)} ${lockerPiece("B", 2)} ${lockerPiece("B", 3)}
            ${lockerPiece("B", 4)}
          </div>
          <div class="locker-row">
            ${lockerPiece("C", 1)} ${lockerPiece("C", 2)} ${lockerPiece("C", 3)}
            ${lockerPiece("C", 4)}
          </div>
          <div class="locker-row">
            ${lockerPiece("D", 1)} ${lockerPiece("D", 2)} ${lockerPiece("D", 3)}
            ${lockerPiece("D", 4)}
          </div>
        </div>

        <img src=${background} class="locker-background" />
      </div>
    `;
    // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
    puzzleWindow = CreateWindow({
      exitCallback: () => {
        tips.solveCameraLocker.setTime(20)
      },
    })
    render(markup, puzzleWindow.element);
  };


  renderStuff();

  // Create our stylesheet
  var style = document.createElement("style");
  style.innerHTML = `
    .locker-row {
      border: 1px solid white;
    }

    .locker-grid {
      border 1px solid white;
    }
  `;

  function changeValue(row, col) {
    if(data[row][col]) {
      window.scene.getSoundByName("cameraLockerButtonActive")?.play();
    }

    if(!data[row][col]) {
      window.scene.getSoundByName("cameraLockerButtonDeactive")?.play();
    }
    data[row][col] = !data[row][col];
    let correctAnswer = equal(data, correct);
    let correctCallback = () => endAnimation(renderStuff);
    if (correctAnswer) {
      window.setTimeout(puzzleWindow.exit, 500)
      window.setTimeout(callback, 1500)
    }
    renderStuff();
  }

  // Get the first script tag
  var ref = document.querySelector("script");

  exitButtonPosition();
  // Insert our new styles before the first script tag
  //ref.parentNode.insertBefore(style, ref);
};

export default FlatPuzzle;
